// extracted by mini-css-extract-plugin
export default {"sectionTitle":"vu9vLY","tldChip":"wEtt7K","tldChipSelected":"ZTwofA","tldChipBorderSweep":"HyBfJW","skeletonChipGroup":"xzYTop","skeletonChip":"BcubpS"};